import { ICitizenship } from 'interfaces'
import { useEffect, useState } from 'react'
import { registryService } from 'services'

function useCitizenship(setError?: (error: any) => void) {
  const [citizenship, setCitizenship] = useState<ICitizenship[]>([])

  useEffect(() => {
    const controller = registryService.getCitizenship(setCitizenship, setError)
    return () => controller.abort()
  }, [setError])

  return citizenship
}

export default useCitizenship
